import { CustomField } from "@/app/components/form-fields/atoms";
import { Entity, IBooleanField } from "@/app/fields/types";
import { Checkbox } from "@chakra-ui/react";

export const BooleanFormField = <T extends Entity>({
  field,
  isDisabled,
}: {
  field: IBooleanField<T>;
  isDisabled?: boolean;
}) => {
  return (
    <CustomField
      field={field}
      isDisabled={isDisabled}
      render={({ field: { onChange, value, ...rest } }) => {
        return (
          <div
            style={{ minHeight: "var(--chakra-sizes-9)" }}
            className="flex items-center"
          >
            <Checkbox
              {...rest}
              id={`form-field-${String(field.field)}`}
              isDisabled={isDisabled}
              required={field.is_required}
              isChecked={value}
              onChange={onChange}
            >
              {field.form_label}
            </Checkbox>
          </div>
        );
      }}
    />
  );
};
